export enum Types {
	FETCH_POKEMONS_REQUEST = "FETCH_POKEMONS_REQUEST",
	FETCH_POKEMONS_SUCCESS = "FETCH_POKEMONS_SUCCESS",
	FETCH_POKEMONS_FAILED = "FETCH_POKEMONS_FAILED",
}
